import { render } from "./Promociones.vue?vue&type=template&id=d07e9ee2"
import script from "./Promociones.vue?vue&type=script&lang=js"
export * from "./Promociones.vue?vue&type=script&lang=js"

import "./Promociones.vue?vue&type=style&index=0&id=d07e9ee2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__